/**
*
*   Affirm Display Library
*       - Manages Sending Email
*
**/

/**
*
*   Shopify Requesat Class
*
*
**/
const Affirm = (()=>{
	return {

		//Get an Offer
		get: async ({ amount , pageType , locale }) => {

			//Get the URL
			const url = `https://www.affirm.ca/api/promos/v2/${ '64OGUTPXRPIHGT2G' }?amount=${ amount * 100 }&use_best_terms=true&page_type=${ pageType }&template_field=${ locale }`;

			//Get the Request
			const request = await fetch( url );

			//Get the Response
			const response = await request.json();

			//No Promo Offered
			if( !response.promo ) return false;

			//Return the HTML
			return response.promo.ala.replace(/\s+Learn More/gi,'').replace(/(Affirm)/g,'<span class="__affirm-logo __affirm-logo-blue __ligature__affirm_full_logo__ __processed">Affirm</span>');

		}
	};
});

export default Affirm();